import * as Yup from 'yup';

export const ipv4RegExp =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const ipv6RegExp =
    /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
const floatingPointRegExp = /^(|\+)?([0-9]+(\.[0-9]+)?)$/;
const macAddressRegExp = /^([0-9A-F]{2}[:-]?){5}([0-9A-F]{2})$/;
export const hostnameRegExp =
    /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;
// eslint-disable-next-line
export const urlAddressRegExp =
    /^(https?:\/\/|ftps?:\/\/)?([a-z0-9%\-]+\.){1,}([a-z0-9\-]+)?(:(\d{1,5}))?(\/([a-z0-9\-\|._~:\/\?#\[\]@!$&'\(\)\*\+,;=%]+)?)?$/i;
const domainRegEx = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i;

// Hash RegExp
export const md5RegExp = /^[a-f0-9]{32}$/i;
export const md6RegExp = /^[a-f0-9]{1,128}$/i;
export const sha1RegExp = /^[a-f0-9]{40}$/i;
export const sha224RegExp = /^[a-f0-9]{56}$/i;
export const sha256RegExp = /^[a-f0-9]{64}$/i;
export const sha384RegExp = /^[a-f0-9]{96}$/i;
export const sha512RegExp = /^[a-f0-9]{128}$/i;
export const emailRegExp =
    /^[a-z0-9!#$%&'*+\-/=?^_`{|}~.]+@([a-z0-9%\-]+\.){1,}([a-z0-9\-]+)?$/i;

export function isValidHost(value) {
    return hostnameRegExp.test(value);
}

export function isIpv4Address(value) {
    return ipv4RegExp.test(value);
}

export function isIpv6Address(value) {
    return ipv6RegExp.test(value);
}

export function isFloatingPoint(value) {
    return floatingPointRegExp.test(value);
}

export function returnHashType(value) {
    const patterns = {
        md5: /^[a-f0-9]{32}$/i,
        sha1: /^[a-f0-9]{40}$/i,
        sha256: /^[a-f0-9]{64}$/i
    };

    //RN: check if is a md5 hash
    if (patterns['md5'].test(value)) {
        return 'md5';
    }

    //RN: check if is a sha1 hash
    if (patterns['sha1'].test(value)) {
        return 'sha1';
    }

    //RN: check if is a sha256 hash
    if (patterns['sha256'].test(value)) {
        return 'sha256';
    }

    return false;
}

export function isMd5(value) {
    return md5RegExp.test(value);
}

export function isSha1(value) {
    return sha1RegExp.test(value);
}

export function isSha256(value) {
    return sha256RegExp.test(value);
}

function isHash(value) {
    return isMd5(value) || isSha1(value) || isSha256(value);
}

export function isMacAddress(value) {
    return macAddressRegExp.test(value);
}

export function isEmailAddress(value) {
    return emailRegExp.test(value);
}

export function isValidUrl(value, https = false) {
    if (https && value.substring(0, 5) !== 'https') {
        return false;
    }
    return urlAddressRegExp.test(value);
}

export function isDomain(value) {
    return domainRegEx.test(value);
}

export function isIpOrDomain(value) {
    return isIpv4Address(value) || isDomain(value);
}

export function isUrlAddress(value) {
    const pattern =
        /^(https?:\/\/|ftps?:\/\/)?([a-z0-9%\-]+\.){1,}([a-z0-9\-]+)?(:(\d{1,5}))?(\/([a-z0-9\-._~:\/\?#\[\]@!$&'\(\)\*\+,;=%]+)?)?$/i;

    //RN: general pattern recognition https://regex101.com/r/RgKTA4/2
    var match = value.match(pattern);
    if (match === null) return false;
    //RN: validate TLD
    if (typeof match[3] !== 'string') return false;
    // if(this._tlds.indexOf(match[3].toLowerCase()) === -1) return false;

    //RN: validate port
    if (match[5] && !isPort(match[5])) return false;
    return true;
}
export function isPort(value) {
    if (isNaN(Number(value))) return false;
    if (Number(value) > 65535) return false;
    else return true;
}

export function isValidPort(value) {
    if (isNaN(value) || value < 1 || value > 65535) {
        return false;
    }
    return true;
}

//RN: check if contains only numbers, exclude all chars
export function isPositiveInteger(value) {
    const noChar = value.match(/^\+?[1-9]\d*$/);
    const intVal = parseInt(value);
    if (noChar && Math.sign(intVal) === 1) {
        return true;
    }
    return false;
}

//RN: check if contains only numbers, exclude all char without '-' in front
export function isInteger(value) {
    const noChar = value.match(/^-?\d*$/);
    if (noChar) {
        return true;
    }
    return false;
}

export function getObjectValidator() {
    Yup.addMethod(Yup.string, 'ipv4', function (message) {
        return this.test('ipv4', message, isIpv4Address);
    });

    Yup.addMethod(Yup.string, 'host', function (message) {
        return this.test('host', message, isValidHost);
    });

    Yup.addMethod(Yup.string, 'ipv6', function (message) {
        return this.test('ipv6', message, isIpv6Address);
    });

    Yup.addMethod(Yup.string, 'macAddress', function (message) {
        return this.test('macAddress', message, isMacAddress);
    });

    Yup.addMethod(Yup.string, 'urlAddress', function (message) {
        return this.test('urlAddress', message, isValidUrl);
    });

    Yup.addMethod(Yup.string, 'ipOrDomain', function (message) {
        return this.test('ipOrDomain', message, isIpOrDomain);
    });

    Yup.addMethod(Yup.string, 'hash', function (message) {
        return this.test('hash', message, isHash);
    });

    Yup.addMethod(Yup.number, 'floatingPoint', function (message) {
        return this.test('floatingPoint', message, isFloatingPoint);
    });

    Yup.addMethod(Yup.number, 'port', function (message) {
        return this.test('port', message, isValidPort);
    });

    Yup.addMethod(Yup.string, 'domain', function (message) {
        return this.test('domain', message, isDomain);
    });

    Yup.addMethod(Yup.date, 'format', function () {
        return this.transform(function (value) {
            return new Date(value);
        });
    });

    Yup.addMethod(
        Yup.string,
        'requiredWhenDefined',
        function requiredWhenDefined(message, type) {
            return this.test({
                message: message,
                name: 'requiredWhenDefined',
                test(value) {
                    if (value === undefined) {
                        return true;
                    }

                    if (value === null || value.length === 0) {
                        return true;
                    }

                    switch (type) {
                        case 'ip':
                            return isIpv4Address(value);
                            break;
                        case 'url':
                            return isValidUrl(value);
                            break;
                        case 'port':
                            return isValidPort(value);
                            break;
                        case 'host':
                            return isValidHost(value);
                            break;
                        case 'integer-positive':
                            return isPositiveInteger(value);
                        case 'integer':
                            return isInteger(value);
                        case 'domain':
                            return isDomain(value);
                    }
                }
            });
        }
    );

    return Yup;
}

export function getOneOfSchemasValidator() {
    Yup.addMethod(Yup.MixedSchema, 'oneOfSchemas', function (schemas, message) {
        return this.test('one-of-schemas', message, item =>
            schemas.some(schema => schema.isValidSync(item, { strict: true }))
        );
    });

    return Yup;
}
